import { useToken } from "@dexteel/mesf-core";
import { Button, useTheme } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const AttachmentsDownloadButtons = ({ data }: Props) => {
	const { token: bearerToken } = useToken();
	const theme = useTheme();

	return (
		<Grid2
			container
			spacing={1}
			style={{ display: "flex", alignItems: "center" }}
		>
			{data?.Path && (
				<Grid2 size={{ md: 12, xs: 12 }}>
					<Button
						href={`/backend/files/${data?.UploadFileId}/download?Authorization=${bearerToken}`}
						target="_blank"
						rel="noopener noreferrer"
						variant="outlined"
						style={{
							textDecoration: "none !important",
							fontWeight: 500,
							fontSize: "12px",
							borderRadius: "3px",
							border: `1px solid ${theme.palette.primary.main}`,
							color: theme.palette.primary.main,
						}}
						download={`${data?.FileName} `}
					>
						DOWNLOAD
					</Button>
				</Grid2>
			)}
		</Grid2>
	);
};
